module.exports = __webpack_public_path__ + "static/media/getting-started-system-requirements.1f498120.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/getting-started-system-requirements.md
// module id = 1097
// module chunks = 0